import React from 'react'
import styles from './SectionNav.module.css'

export type SectionNavItem = {
  key: string
  label: string
  isActive: boolean
  onSelect: () => void
}

export type SectionNavProps = {
  items: SectionNavItem[]
  children: React.ReactNode
}

/**
 * Left-side section nav for screens with several genuinely separate
 * concerns stacked in one scroll. Desktop: sticky sidebar. Mobile
 * (<=900px, matching the app's other compact-layout breakpoint):
 * horizontal scroll-tabs above the content.
 */
export default function SectionNav({ items, children }: SectionNavProps) {
  return (
    <div className={styles.layout}>
      <nav className={styles.nav} aria-label="Section navigation">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`${styles.navItem} ${item.isActive ? styles.navItemActive : ''}`}
            aria-current={item.isActive ? 'page' : undefined}
            onClick={item.onSelect}
          >
            {item.label}
          </button>
        ))}
      </nav>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
